export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Consortium.vue?vue&type=template&id=1562b9ea&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/sessions/sections/Consortium.vue?vue&type=template&id=1562b9ea&scoped=true&
// module id = 1544
// module chunks = 0